












import { defineComponent, toRefs } from '~/utils/nuxt3-migration'
import CMapLocationInput from '~/components/shared/configurable/location/CMapLocationInput.vue'
import { DYNAMIC_FORM_FIELD_PROPS } from '~/constants/dynamic-form'
import { useDynamicForm } from '~/compositions/dynamic-form'
import CGoogleMap from '~/components/shared/configurable/map/CGoogleMap.vue'
import { Geolocation } from '~/models/common/types'
import GoogleMapsService from '~/services/GoogleMapsService'
import { useDeps } from '~/compositions/dependency-container'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'

export default defineComponent({
  components: { CFormError, CMapLocationInput, CGoogleMap },
  props: DYNAMIC_FORM_FIELD_PROPS,
  setup(props) {
    const { name } = toRefs(props)
    const { value, error, changeValues } = useDynamicForm(props)
    const [googleMapsService] = useDeps(GoogleMapsService)

    async function handleMarkerChange(geolocation: Geolocation) {
      const { address } = await googleMapsService.getGeocodingProperties(
        geolocation
      )

      value.value = geolocation
      changeValues([
        { name: name.value, value: geolocation },
        { name: 'address', value: address }
      ])
    }

    return { value, error, handleMarkerChange }
  }
})
